module.exports = __webpack_public_path__ + "static/media/placeholder3.791c828e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder3.jpg
// module id = 625
// module chunks = 0